import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1>404</h1>
            <h3>Requested page not found</h3>
        </div>
    );
};

export default NotFound;